import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './app-routes';

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      bindToComponentInputs: true,
      scrollPositionRestoration: 'disabled',
      //enableTracing: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
